module.exports = __webpack_public_path__ + "img/onboarding-color.e78c2af0.png";